import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './ink-boil.css';

// Three fixed pencil contours, held as discrete frames rather than a smooth wobble.
export const InkBoil = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const targets = [...document.querySelectorAll('.App .editorial-handnote:not(.author-side-note), .App .ink-boil-text, .App .blog-hero-handnote, .App .practice-note p, .App .editorial-arrow')].filter(element => !element.closest('[data-ink-static]'));
    const lineTargets = [...document.querySelectorAll('.App .ink-underline, .App .fokeev-hero h1 span, .App .blog-heading h1 span, .App .blog-hero h1 span, .App .catalog-heading h1 .text-transparent, .App .course-catalog-text, .App .hero-stat-rating')];
    const lines = new Set(lineTargets);
    const observed = [...new Set([...targets, ...lineTargets])];
    const visible = new Set();
    const sync = () => observed.forEach(element => element.classList.toggle('ink-boil-running',
      visible.has(element) && !document.hidden && !preference.matches));
    const observer = window.IntersectionObserver ? new IntersectionObserver(entries => {
      entries.forEach(({ target, isIntersecting }) => isIntersecting ? visible.add(target) : visible.delete(target));
      sync();
    }) : null;
    observed.forEach(element => {
      element.classList.add(lines.has(element) ? 'ink-line-boil' : 'ink-boil');
      observer?.observe(element);
    });
    document.addEventListener('visibilitychange', sync);
    preference.addEventListener('change', sync);
    return () => {
      observer?.disconnect();
      document.removeEventListener('visibilitychange', sync);
      preference.removeEventListener('change', sync);
      observed.forEach(element => element.classList.remove('ink-boil', 'ink-line-boil', 'ink-boil-running'));
    };
  }, [pathname]);

  return <svg className="ink-boil-definitions" aria-hidden="true" focusable="false" width="0" height="0">
    <defs>{[9, 17, 29].flatMap((seed, index) => ['text', 'arrow'].map(kind =>
      <filter key={`${kind}-${seed}`} id={`pencil-${kind}-${index}`} x="-8%" y="-12%" width="116%" height="124%" colorInterpolationFilters="sRGB">
        <feTurbulence type="fractalNoise" baseFrequency="0.06" numOctaves="2" seed={seed} result="grain" />
        <feDisplacementMap in="SourceGraphic" in2="grain" scale={kind === 'text' ? '2' : '3'} xChannelSelector="R" yChannelSelector="G" />
      </filter>))}</defs>
  </svg>;
};
